/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import { LayoutSplashScreen } from "../../_metronic";

const LandingPagePage = lazy(() => import("../pages/landing-page/LandingPagePage"));
const OnboardingPage = lazy(() => import("../pages/onboarding/OnboardingPage"));

export const Routes = () => {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter>
                <Switch>
                    <Redirect exact from="/" to="/lp" />

                    <Route path="/lp/:slug?" component={LandingPagePage} />
                    <Route path="/onboarding" component={OnboardingPage} />

                    <Route path="/*" component={LandingPagePage} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};
